import CalendarScreen from "../../assets/Screens/Calendar.png";
import CalendarScreenMobile from "../../assets/Screens/CalendarMobile.png";

export default function Calendar() {
  return (
    <section id="calendar" className="md:h-[722px] md:px-[24px]">
      <div className="mx-auto max-w-[995px] w-full h-full pt-[40px] md:pt-0 md:relative flex flex-col md:flex-row items-center">
        <div className="z-10 max-w-[255px] md:max-w-[450px] w-full flex flex-col gap-[20px] md:gap-[32px] text-center md:text-left">
          <h2>Сохраняй воспоминания в дневнике</h2>
          <p className="subtitle">
            Дневник-календарь хранит твои текстовые и аудио записи, важные
            моменты из диалогов и настроение каждого дня
          </p>
        </div>

        <img
          src={CalendarScreen}
          alt="Calendar"
          className="hidden md:block absolute top-1/2 -translate-y-[calc(50%-38px)] -right-[96px] lg:right-0 h-[560px] transition-all"
        />
        <img
          src={CalendarScreenMobile}
          alt="Calendar"
          className="block md:hidden top-1/2 right-0 h-[526px] transition-all"
        />
      </div>
    </section>
  );
}
